<template>
  <transition name="loader-fade">
    <div class="ks-loading-splash" :style="styles" v-if="showLoadingIndicator">
      <div :class="[spinnerClass]"></div>
      <div v-if="showLoadingText && loadingText !== ''" :class="[textClass]">
        {{ loadingText }}
      </div>
      <slot />
    </div>
  </transition>
</template>

<script>
  import LoadingDelayMixin from 'Mixins/LoadingDelayMixin'

  export default {
    mixins: [LoadingDelayMixin],
    computed: {
      spinnerClass () {
        const classBase = 'ks-loading-splash-spinner'
        const lowerSize = this.size.toLowerCase()

        return `${classBase}-${lowerSize} ${classBase}-${lowerSize}--dark`
      },
      textClass () {
        const classBase = 'ks-loading-splash-text'
        const lowerSize = this.size.toLowerCase()

        return `${classBase}-${lowerSize}`
      },
      styles () {
        if (this.minHeight) {
          return {
            'min-height': this.minHeight,
          }
        } else {
          return {}
        }
      },
    },
    props: {
      loadingText: {
        type: String,
        default: 'Loading',
      },
      size: {
        type: String,
        default: 'sm',
      },
      minHeight: {
        type: String,
        default: '',
      },
      showLoadingText: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  @use "~Styles/colors";
  @use "~Styles/mixins";
  
  .ks-loading-splash {
    align-items: center;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    height: 100%;
    left: 0;
    justify-content: center;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%;

    &-text {
      &-lg {
        font-size: 36px;
        margin-top: 15px;
      }

      &-md {
        font-size: 24px;
        margin-top: 8px
      }

      &-sm {
        font-size: 14px;
        margin-top: 8px;
      }
    }

    &-spinner {
      &-lg {
        @include mixins.spinner(40px, 4px);
      }

      &-md {
        @include mixins.spinner(32px, 3px);
      }

      &-sm {
        @include mixins.spinner(18px, 2px);
      }
    }
  }

  .loader-fade-enter-active,
  .loader-fade-leave-active {
    transition: opacity .5s;
  }

  .loader-fade-enter,
  .loader-fade-leave-to {
    opacity: 0;
  }
</style>
